import React from 'react'
import CustomButton from './Buttons'

const Hero = () => {
  const text = "CYdZszyRqn5C9wiSrEvh9cZgeo3UeWb1mj1HiNBppump"
  const copyToClipboard = () => {
    navigator.clipboard.writeText(text)
      .then(() => alert('Text copied to clipboard!'))
      .catch(err => console.error('Failed to copy text:', err));
  };
  return (
    <div className='min-h-[80vh] w-[100vw] flex flex-col justify-center items-center bg1 text-white'>
        <img className='w-[90%] max-w-[600px] shake' src={require('../assets/logo.png')}/>
        <img className='w-[90%] max-w-[400px]' src={require('../assets/1.gif')}/>
        <div className='flex justify-center items-center space-x-4 my-4'>
            <CustomButton link="https://pump.fun/coin/CYdZszyRqn5C9wiSrEvh9cZgeo3UeWb1mj1HiNBppump" label="Pump"/>
            <CustomButton link="https://photon-sol.tinyastro.io/en/lp/hpLv1aba3y4JpFYE9KpaLcspW4pMLsUNS3mT9hpFo6b" label="Photon"/>
        </div>
        <div>
            <div
            onClick={copyToClipboard} 
            className='text-center tracking-[2px] font1 text-black text-[14px] md:text-[42px] mb-10 mt-6'>
                <p>CA: {text}</p>
            </div>
        </div>
    </div>
  )
}

export default Hero